import React, { FC, useEffect, useState } from 'react'
import Helmet from 'react-helmet'
import { useDispatch, useSelector } from 'react-redux'
import { RootState } from '../../../../states/containers/store'
import { fetchSettingPersonal } from '../../../../states/containers/setting/systemSlice'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { URL } from '../../../constants/url'
import { useHistory } from 'react-router-dom'
import { setPath } from '../../../../utils/url'
import { responseGetSettingPersonal, settingPersonalSettingDetail } from '../../../../states/types/setting'
import LoadingSquare from '../../../components/common/LoadingSquare'

const PERSONAL_LIST = [
  {
    key: "profile",
    title: "プロフィール設定",
    description: "プロフィールを設定します。",
    url: URL.SETTING_PROFILE.path,
  },
  {
    key: "client_download",
    title: "QaseeClientのダウンロード",
    description: "QaseeClientアプリをダウンロードできます。",
    url: URL.SETTING_CLIENT_DOWNLOAD.path,
  },
  {
    key: "mfa_auth_setting",
    title: "多要素認証設定",
    description: "多要素認証を設定します。",
    url: URL.SETTING_MFA_AUTH.path,
  },
  {
    key: "oauth_setting",
    title: "外部サービス連携",
    description: "カレンダーの同期やSSO・通知設定ができます。",
    url: URL.SETTING_OAUTH.path,
  },
  {
    key: "mail_delivery_setting",
    title: "配信メール設定",
    description: "配信されるメールの受け取りを設定します。",
    url: URL.SETTING_MAIL_DELIVERY.path,
  },
  {
    key: "measurement_setting",
    title: "計測時間設定",
    description: "個別にQaseeで計測する時間を設定できます。",
    url: URL.SETTING_INDIVIDUAL_MEASUREMENT.path,
  },
]

type PersonalSettingKeys = keyof settingPersonalSettingDetail

const Index: FC = () => {
  const dispatch = useDispatch()
  const { login } = useSelector<RootState, RootState>((state: RootState) => (state))
  const history = useHistory()

  const [settingPersonal, setSettingPersonal] = useState<responseGetSettingPersonal>()
  const [isLoading, setIsLoading] = useState<boolean>(true)

  const buildCard = (data: { title: string, description: string, url: string, check: boolean }) => (
    <button
      type="button"
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        gap: "4px",
        border: "solid 1px #CCCCCC",
        borderRadius: "4px",
        padding: "16px",
        width: "calc(50% - 8px)",
        backgroundColor: "#EEEEEE",
      }}
      onClick={() => history.push(setPath(data.url, "ja"))}
    >
      <div
        style={{
          display: "flex",
          alignItems: "center",
          gap: "12px",
        }}
      >
        <div
          style={{
            position: "relative",
            width: "40px",
            height: "40px",
            backgroundColor: data.check ? "#487fce" : "#FFFFFF",
            borderRadius: "50%",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            color: "#FFFFFF",
            fontSize: "22px",
            padding: "8px",
          }}
        >
          <img
            src="/static/images/logo_q.png"
            alt=""
            style={{
              width: "auto",
              height: "100%",
              filter: data.check ? "saturate(0%) brightness(2)" : "saturate(0%) brightness(1.5)",
            }}
          />
          {
            !data.check && (
              <div
                style={{
                  position: "absolute",
                  bottom: "-5px",
                  color: "#999999",
                  fontSize: "10px",
                  whiteSpace: "nowrap",
                }}
              >
                未設定
              </div>
            )
          }
        </div>
        <div
          style={{
            display: "flex",
            flexFlow: "column",
            gap: "4px",
          }}
        >
          <div
            style={{
              fontSize: "18px",
            }}
          >
            {data.title}
          </div>
          <div>
            {data.description}
          </div>
        </div>
      </div>
      <FontAwesomeIcon icon={['fas', 'angle-right']} />
    </button>
  )

  useEffect(() => {
    if (!login.accessToken) return
    setIsLoading(true)
    dispatch(
      fetchSettingPersonal(
        (result) => {
          setSettingPersonal(result)
          setIsLoading(false)
        },
      ),
    )
  }, [login.accessToken])

  return (
    <section className="setting_page">
      <Helmet>
        <title>Qasee - 設定 - 個人設定</title>
      </Helmet>
      <section className="breadcrumb">
        設定
        &nbsp;&gt;&nbsp;
        個人設定
        &nbsp;
      </section>
      <section className="page_header">
        <h1>
          個人設定
        </h1>
      </section>
      <section className="page_contents content-area">
        <div className="content-block">
          <div className="block-detail">
            {
              isLoading ? (
                <>
                  <LoadingSquare>
                    <>
                      情報を取得しています…
                    </>
                  </LoadingSquare>
                </>
              ) : (
                <>
                  <div
                    style={{
                      display: "flex",
                      gap: "16px",
                      flexWrap: "wrap",
                    }}
                  >
                    {
                      PERSONAL_LIST.map((data) => (
                        <>
                          {
                            buildCard({
                              ...data,
                              check: settingPersonal?.setting[data.key as PersonalSettingKeys] ?? true,
                            })
                          }
                        </>
                      ))
                    }
                  </div>
                </>
              )
            }
          </div>
        </div>
      </section>
    </section>
  )
}

export default Index
